// contexts/DataContext.js
import React, { createContext, useState, useEffect } from 'react';
import { USE_LOCAL_DATA, API_URL } from '../config';

export const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

 useEffect(() => {
  const fetchData = async () => {
    try {
      const params = new URLSearchParams(window.location.search);
      let qrCode = params.get('qr');

      // ✅ ローカルモードかつQRパラメータがない場合、デフォルト値をセット
      if (USE_LOCAL_DATA && !qrCode) {
        qrCode = 'test-local-qr-code-1234'; // ← 任意のテスト用UUID
        const newUrl = `${window.location.pathname}?qr=${qrCode}`;
        window.history.replaceState({}, '', newUrl);
      }

      if (!qrCode) {
        console.error('QR code parameter is missing');
        return;
      }

      const response = USE_LOCAL_DATA
        ? await fetch('/data/data.json')
        : await fetch(`${API_URL}?qr=${qrCode}`);

      if (!response.ok) throw new Error('Network response was not ok');
      const json = await response.json();
      setData(json);
    } catch (error) {
      console.error('Data fetching error:', error);
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, []);

  return (
    <DataContext.Provider value={{ data, loading }}>
      {children}
    </DataContext.Provider>
  );
};
